import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfigurationService } from '../configuration.service';

@Component({
  selector: 'app-user-create-dialog',
  templateUrl: './user-create-dialog.component.html',
  styleUrls: ['../configuration-form.css'],
})
export class UserCreateDialogComponent {
  form: FormGroup;
  submitting = false;
  emailError = '';
  error = '';

  constructor(
    private fb: FormBuilder,
    private api: ConfigurationService,
    private dialogRef: MatDialogRef<UserCreateDialogComponent>
  ) {
    this.form = this.fb.group({
      emailAddress: ['', [Validators.required, Validators.email, Validators.maxLength(256)]],
      displayName:  ['', Validators.maxLength(120)],
      userName:     ['', Validators.maxLength(64)],
      password:     ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  submit(): void {
    if (this.form.invalid || this.submitting) return;
    this.submitting = true;
    this.emailError = '';
    this.error = '';
    const v = this.form.value;
    this.api.createUser({
      emailAddress: v.emailAddress,
      displayName:  v.displayName || null,
      userName:     v.userName || null,
      password:     v.password,
    }).subscribe({
      next: () => this.dialogRef.close({ created: true }),
      error: err => {
        this.submitting = false;
        if (err.status === 409) {
          this.emailError = 'This email address is already in use';
        } else if (err.status === 403) {
          this.error = "You don't have permission to create users.";
        } else {
          this.error = err.error?.message || `Couldn't create user (error ${err.status || 'network'}).`;
        }
      }
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
